import { createContext, useContext } from "react";

/** "filters" | "actions" | false — tells children which ControlBar slot they're in */
type ControlBarSlot = "filters" | "actions" | false;

const ControlBarContext = createContext<ControlBarSlot>(false);

export const ControlBarProvider = ControlBarContext.Provider;
export const useControlBarSlot = () => useContext(ControlBarContext);
